export default {"src":"/_next/static/media/icon-page-right.65acbc86.svg","height":8,"width":6};